import { StackView, Divider } from '@planningcenter/tapestry-react';
import React from 'react';
import { noop } from '../../utils/index.js';
import { NewChatViewFooter } from '../new_chat_view/footer.js';
import 'stream-chat-react';
import '../../chat_context.js';
import '../../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { People } from './people.js';
import { Plans } from './plans.js';
import { Teams } from './teams.js';
import { NEW_SERVICES_CHAT_FOOTER_TEXT } from './constants.js';
import { useServicesChatFilter } from './hooks/use_services_chat_filter.js';
import { PeopleBlankState } from './people_blank_state.js';

const ServicesChatOptions = ({ isActive }) => {
    const { filterValues, setFilterValues, isFiltering, isPlansActive } = useServicesChatFilter(isActive);
    return (React.createElement(StackView, { grow: 1 },
        React.createElement(StackView, { spacing: 2, padding: 2, paddingTop: 0 },
            React.createElement(Teams, { values: filterValues, onChange: setFilterValues, isActive: isActive }),
            React.createElement(Plans, { values: filterValues, onChange: setFilterValues, isActive: isPlansActive })),
        React.createElement(Divider, null),
        isFiltering ? (React.createElement(People, { filter: filterValues })) : (React.createElement(React.Fragment, null,
            React.createElement(PeopleBlankState, null),
            React.createElement(NewChatViewFooter, { text: NEW_SERVICES_CHAT_FOOTER_TEXT, buttonDisabled: true, showSpinner: false, onButtonClick: noop })))));
};

export { ServicesChatOptions };
//# sourceMappingURL=services_chat_options.js.map
